export default "__VITE_ASSET__47dc923b__"